import { useTranslation } from "react-i18next";
import {
  getRubricGenerator,
  useCreateRubricGenerator,
  useGetRubricGenerator,
} from "@packages/api/madlenAPI";
import { CreateModalProps } from "../../../components/create-modal";
import { RubricCard } from "../../../components/rubric/RubricCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import { RubricGeneratorResponseDto } from "@packages/api/madlenAPI.schemas";
import { RubricCreateModal } from "@features/tools/components/create-modal/rubric/RubricCreateModal";

const CreateRubricView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <RubricCreateModal
      themeColor="green"
      title={t("quickActions.rubricCreate")}
      backPath="/content/rubric"
      loadingTitle={t("rubric.submit.loading.title")}
      errorTitle={t("rubric.submit.error.title")}
      errorDescription={t("rubric.submit.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!({ ...input, title: input.prompt });
      }}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: RubricGeneratorResponseDto;
    isImageLoading: boolean;
    onCreateAgain: () => void;
  }) => (
    <RubricCard
      rubric={toolData}
      isImageLoading={isImageLoading}
      onCreateAgain={onCreateAgain}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="rubric"
      useCreateTool={useCreateRubricGenerator}
      useGetTool={useGetRubricGenerator}
      getTool={getRubricGenerator}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: RubricGeneratorResponseDto) =>
        (data?.rubricType === "ANALYTIC" &&
          data?.criteria &&
          data?.criteria?.length > 0) ||
        (data?.rubricType === "HOLISTIC" &&
          data?.levelDescriptions &&
          data?.levelDescriptions?.length > 0)
      }
    />
  );
};

export default CreateRubricView;
